export const Images = {
  Background: require('./background.jpg'),
  Logo: require('./logo.png')
}
